module.exports = __webpack_public_path__ + "static/transactionalemail-cta-do-02c144b6976b647841f21758cd164d2f.png";